// productId/assocPriceTypeId carry no length/format constraints beyond "is a valid UUID" / "is a
// known AssocPriceType" (enforced in input.ts) -- these labels exist purely so upsert/delete error
// messages stay consistent if either entity's user-facing name ever changes.
export const NAME_MAX_LENGTH = 60;
export const ASSOC_PRICE_CONSTRAINTS = {
    productId: { label: 'Product' },
    assocPriceTypeId: { label: 'Price type' },
    name: { maxLength: NAME_MAX_LENGTH, label: 'Name' },
    price: { label: 'Price', max: 1_000_000_000 },
    percentageAdjustment: { label: 'Percentage adjustment' },
    flatAdjustment: { label: 'Flat adjustment' },
};
//# sourceMappingURL=constraints.js.map